module.exports = __webpack_public_path__ + "static/media/IMAGE-5-MILK-BOTTLES-desktop.a48b1e01.jpg";